import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {LocalCustomerFilterComponent} from '../../../general-components/filter/local-customer-filter/local-customer-filter.component';
import {NumAnnoMeseFilterComponent} from '../../../general-components/filter/num-anno-mese-filter/num-anno-mese-filter.component';
import {RegionFilterComponent} from '../../../general-components/filter/region-filter/region-filter.component';
import {DeltaChargesModel, DeltaChargesReportModel} from '../../../../models/DeltaChargesModel';
import {ContractTypeFilterComponent} from '../../../general-components/filter/contract-type-filter/contract-type-filter.component';
import {LoaderService} from '../../../general-services/service-loader/loader.service';
import {DeltaChargesService} from '../service-delta-charges/delta-charges.service';
import {forkJoin, Observable, Subscription} from 'rxjs';
import {Offset} from 'src/models/Offset';
import * as toastr from 'toastr';
import {DeltaFilterComponent} from 'src/app/general-components/filter/delta-filter/delta-filter.component';
import {ClaimsFilterComponent} from 'src/app/general-components/filter/claims-filter/claims-filter.component';
import * as FileSaver from 'file-saver';
import {AllSettingsFilterModel} from '../../../../models/AllSettingsFilterModel';
import {NumAnnoMeseService} from '../../../general-services/service-num-anno-mese/num-anno-mese.service';
import {RegionService} from '../../../general-services/service-region-anagraf/region-service.service';
import {LocalCustomerAnagrafService} from '../../../general-services/service-local-customer-anagraf/local-customer-anagraf.service';
import {ContractTypeService} from '../../../general-services/service-contract-type/contract-type.service';
import {MatDialog} from '@angular/material/dialog';
import {BaseGeneralComponent} from '../../../BaseGeneralComponent';
import {GenericArray} from '../../../../models/GenericArray';
import {DialogYearMonthComponent} from '../../../general-components/dialog-year-month/dialog-year-month.component';
import {ResourceUnitFilterComponent} from '../../../general-components/filter/resource-unit-filter/resource-unit-filter.component';
import {ResourceUnitService} from '../../../general-services/service-resources-units-anagraf/resource-unit.service';
import {DialogSendEmailComponent} from '../../../general-components/dialog-send-email/dialog-send-email.component';
import { ReferenceMonthFilterComponent } from 'src/app/general-components/filter/reference-month-filter/reference-month-filter.component';
import { ServicesCountryService } from "src/app/general-services/service-services-country/services-country.service";
import { BillingCountryService } from "src/app/general-services/service-billing-country/billing-country.service";
import { urls } from "src/services/api/urls";
@Component({
  selector: 'app-filter-delta-charges',
  templateUrl: './filter-delta-charges.component.html',
  styleUrls: ['./filter-delta-charges.component.scss']
})
export class FilterDeltaChargesComponent extends BaseGeneralComponent implements OnInit, OnDestroy {

  @Input() numAnnoMeseData?: any;
  @Input() filter: DeltaChargesModel;
  @Input() reportSection?: boolean;
  @Input() isComparing?: boolean;

  contractTypeData?: any;
  regionData: any;
  localCustomerData: any;
  resourceUnitData: any;
  srvData: any;
  servicesCountryData: any;
  billingCountryData: any;

  @Output() dataFiltered = new EventEmitter<any>();
  @Output() resetDataFiltered = new EventEmitter<any>();

  @ViewChild(LocalCustomerFilterComponent) localCustomerFilterComponent;
  @ViewChild(NumAnnoMeseFilterComponent, { static: true }) numAnnoFilterComponent;
  @ViewChild(ReferenceMonthFilterComponent, { static: true }) referenceMonthFilterComponent;
  @ViewChild(RegionFilterComponent, { static: true }) regionFilterComponent;
  @ViewChild(ContractTypeFilterComponent, { static: true }) contractTypeFilterComponent;
  @ViewChild(DeltaFilterComponent, { static: true }) deltaFilterComponent;
  @ViewChild(ClaimsFilterComponent, { static: true }) claimsFilterComponent;
  @ViewChild(ResourceUnitFilterComponent, { static: true }) resourceUnitFilterComponent;

  filterSingle: AllSettingsFilterModel;
  getNameSubscribe: Subscription;
  downloadSubscribe: Subscription;
  deltaSignificativo: any;
  offset: Offset;
  claims: any;
  labelAnnoMeseRif: string;
  fileName: string;
  dataSource: any;
  intermittentBool: boolean;

  constructor(private loaderService: LoaderService,
              private deltaChargesService: DeltaChargesService,
              private numAnnoMeseService: NumAnnoMeseService,
              private regionService: RegionService,
              private localCustomerService: LocalCustomerAnagrafService,
              private contractTypeService: ContractTypeService,
              private dialog: MatDialog,
              private resourceUnitService: ResourceUnitService,
              private servicesCountryService: ServicesCountryService,
              private billingCountryService: BillingCountryService
              ) {
    super();
    this.loaderService.display(true);
  }

  ngOnInit() {
    if (!this.filter) {
      this.filter = new DeltaChargesModel();
    }
    this.filterSingle = AllSettingsFilterModel.getFromDeltaChargesModel(this.filter);
    this.offset = new Offset(+this.PAGINATOR.PAGE_SIZE_ARRAY[0], 0);
    if (JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DELTA_CHARGES_FILTER))) {
      this.filter = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DELTA_CHARGES_FILTER));
    }

    this.initFilter(this.filterSingle);
  }

  initFilter(allSettingsFilterModel: AllSettingsFilterModel, isReset?: boolean) {
    const getAllRegionObservable: Observable<any> = this.regionService.getListInAllSettings(
      this.regionService.baseUrl,
      allSettingsFilterModel).pipe();
    const getAllLocalCustomerObservable: Observable<any> = this.localCustomerService.getListInAllSettings(
      this.localCustomerService.baseUrl,
      allSettingsFilterModel).pipe();
    const getAllContractTypeObservable: Observable<any> = this.contractTypeService.getListInAllSettings(
      this.contractTypeService.baseUrl,
      allSettingsFilterModel).pipe();
    const getAllResourceUnitFilterObservable: Observable<any> = this.resourceUnitService.getListInAllSettings(
      this.resourceUnitService.baseUrl,
      this.filterSingle).pipe();
    const getAllSrvObservable: Observable<any> = this.contractTypeService.getSrvInAllSettings(
          urls.contractType,
          allSettingsFilterModel).pipe();
    const getAllServicesCountryObservable: Observable<any> = this.servicesCountryService.getServicesCountryInAllSettings(
          urls.deltaCharges, 
          allSettingsFilterModel).pipe();
    const getAllBillingCountryObservable: Observable<any> = this.billingCountryService.getBillingCountryInAllSettings(
          urls.deltaCharges, 
          allSettingsFilterModel).pipe();


    forkJoin([
      getAllRegionObservable, 
      getAllLocalCustomerObservable, 
      getAllContractTypeObservable, 
      getAllResourceUnitFilterObservable,
      getAllSrvObservable,
      getAllServicesCountryObservable,
      getAllBillingCountryObservable
    ])
      .subscribe(
        (resultFork: any) => {
          this.regionData = resultFork[0];
          this.localCustomerData = resultFork[1];
          this.contractTypeData = resultFork[2];
          this.resourceUnitData = resultFork[3];
          this.srvData = resultFork[4];
          this.servicesCountryData = resultFork[5];
          this.billingCountryData = resultFork[6];

          if (!isReset) {
            this.loaderService.display(false);
          } else {
            this.dataFiltered.emit(this.filter);
          }
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });


  }

  interceptSrvChange(value: string) {
    this.filter.srv = value;
    if (!this.reportSection) {
      this.intermittentBool = value !== '' && value !== null;
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptServiceCountryChange(value: string) {
    this.filter.servicesCountry = value;
    if (!this.reportSection) {
      this.intermittentBool = value !== '' && value !== null;
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptBillingCountryChange(value: string) {
    this.filter.billingCountry = value;
    if (!this.reportSection) {
      this.intermittentBool = value !== '' && value !== null;
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptRegionChange(event) {

    if(!this.filter.provider.cod.includes("KYN"))
      this.filter.region = event;
    
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentFilterButton(true);
    }

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.region = event;

    const getAllLocalCustomerFilteredObservable: Observable<any> = this.localCustomerService.getListInAllSettings(
      this.localCustomerService.baseUrl,
      this.filterSingle).pipe();
    const getAllContractTypeFilteredObservable: Observable<any> = this.contractTypeService.getListInAllSettings(
      this.contractTypeService.baseUrl,
      this.filterSingle).pipe();
    const getAllResourceUnitFilterObservable: Observable<any> = this.resourceUnitService.getListInAllSettings(
      this.resourceUnitService.baseUrl,
      this.filterSingle).pipe();

    observableList.push(getAllLocalCustomerFilteredObservable);
    observableList.push(getAllContractTypeFilteredObservable);
    observableList.push(getAllResourceUnitFilterObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          this.localCustomerData = resultFork[0];
          this.contractTypeData = resultFork[1];
          this.resourceUnitData = resultFork[2];

          this.filter.region = this.filterSingle.region;
          this.filter.localCustomer = this.filterSingle.localCustomer;

          this.loaderService.display(false);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  interceptLocalCustomerChange(event) {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.localCustomer = event;

    const getAllRegionFilteredObservable: Observable<any> = this.regionService.getListInAllSettings(
      this.regionService.baseUrl,
      this.filterSingle).pipe();
    const getAllContractTypeFilteredObservable: Observable<any> = this.contractTypeService.getListInAllSettings(
      this.contractTypeService.baseUrl,
      this.filterSingle).pipe();
    const getAllResourceUnitFilterObservable: Observable<any> = this.resourceUnitService.getListInAllSettings(
      this.resourceUnitService.baseUrl,
      this.filterSingle).pipe();

    observableList.push(getAllRegionFilteredObservable);
    observableList.push(getAllContractTypeFilteredObservable);
    observableList.push(getAllResourceUnitFilterObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          this.regionData = resultFork[0];
          this.contractTypeData = resultFork[1];
          this.resourceUnitData = resultFork[2];

          this.filter.region = this.filterSingle.region;
          this.filter.contractType = this.filterSingle.contractType;

          this.loaderService.display(false);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  interceptContractTypeChange(event) {

    if(!this.filter.provider.cod.includes("KYN"))
      this.filter.contractType = event;

    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.contractType = event;

    /** const getAllNumAnnoMeseFilteredObservable: Observable<any> = this.numAnnoMeseService.getAllMonth(
      this.filterSingle.contractType).pipe(); **/
    const getAllRegionFilteredObservable: Observable<any> = this.regionService.getListInAllSettings(
      this.regionService.baseUrl,
      this.filterSingle).pipe();
    const getAllLocalCustomerFilteredObservable: Observable<any> = this.localCustomerService.getListInAllSettings(
      this.localCustomerService.baseUrl,
      this.filterSingle).pipe();
    const getAllResourceUnitFilterObservable: Observable<any> = this.resourceUnitService.getListInAllSettings(
      this.resourceUnitService.baseUrl,
      this.filterSingle).pipe();

    // observableList.push(getAllNumAnnoMeseFilteredObservable);
    observableList.push(getAllRegionFilteredObservable);
    observableList.push(getAllLocalCustomerFilteredObservable);
    observableList.push(getAllResourceUnitFilterObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          // this.numAnnoMeseData = resultFork[0];
          this.regionData = resultFork[0];
          this.localCustomerData = resultFork[1];
          this.resourceUnitData = resultFork[2];

          this.filter.region = this.filterSingle.region;
          this.filter.localCustomer = this.filterSingle.localCustomer;

          /** if (!BaseGeneralComponent.isNumAnnoMeseInFilterList(this.filter.numAnnoMese, this.numAnnoMeseData)) {
            const numAnnoMese = this.numAnnoMeseData[0] ? this.numAnnoMeseData[0] : null;
            this.filter.numAnnoMese = numAnnoMese;
          }**/

          this.loaderService.display(false);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  interceptResourceUnitChange(event) {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.resourceUnit = event;

    /** const getAllNumAnnoMeseFilteredObservable: Observable<any> = this.numAnnoMeseService.getAllMonth(
     this.filterSingle.contractType).pipe(); **/
    const getAllRegionFilteredObservable: Observable<any> = this.regionService.getListInAllSettings(
      this.regionService.baseUrl,
      this.filterSingle).pipe();
    const getAllLocalCustomerFilteredObservable: Observable<any> = this.localCustomerService.getListInAllSettings(
      this.localCustomerService.baseUrl,
      this.filterSingle).pipe();
    const getAllContractTypeFilteredObservable: Observable<any> = this.contractTypeService.getListInAllSettings(
      this.resourceUnitService.baseUrl,
      this.filterSingle).pipe();

    // observableList.push(getAllNumAnnoMeseFilteredObservable);
    observableList.push(getAllRegionFilteredObservable);
    observableList.push(getAllLocalCustomerFilteredObservable);
    observableList.push(getAllContractTypeFilteredObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          // this.numAnnoMeseData = resultFork[0];
          this.regionData = resultFork[0];
          this.localCustomerData = resultFork[1];
          this.contractTypeData = resultFork[2];

          this.filter.region = this.filterSingle.region;
          this.filter.localCustomer = this.filterSingle.localCustomer;

          /** if (!BaseGeneralComponent.isNumAnnoMeseInFilterList(this.filter.numAnnoMese, this.numAnnoMeseData)) {
            const numAnnoMese = this.numAnnoMeseData[0] ? this.numAnnoMeseData[0] : null;
            this.filter.numAnnoMese = numAnnoMese;
          }**/

          this.loaderService.display(false);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  interceptNumAnnoMeseChange($event: any) {
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptNumAnnoMeseFromChange($event: any) {
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptIsDeltaSignificativoChange($event: any) {
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptIsClaimsChange($event: any) {
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  filterTable(): void {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = false;
      this.intermittentFilterButton(this.intermittentBool);
    }

    this.getAllFilters();
    if (!this.reportSection) {
      sessionStorage.setItem(this.SESSION_STORAGE_LABELS.DELTA_CHARGES_FILTER, JSON.stringify(this.filter));
    }
    this.dataFiltered.emit(this.filter);
  }

  reset() {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = false;
      this.intermittentFilterButton(this.intermittentBool);
    }

    const isReset = true;
    this.filter = new DeltaChargesModel();
    this.filter.provider = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED));
    this.filter.isRecovery = false;
    this.filterSingle = AllSettingsFilterModel.getFromDeltaChargesModel(this.filter);
    this.deltaFilterComponent.reset();
    this.claimsFilterComponent.reset();
    if(!this.filter.provider.cod.includes('KYN')){
      this.filter.contractType = null;
      this.filter.region = null;
    }

    
    this.filter.resourceUnit = null;
    this.filter.numAnnoMeseRif = null;

    this.referenceMonthFilterComponent.reset();
    
    this.resourceUnitFilterComponent.reset();

    this.numAnnoMeseService.getAllMonth(this.filter.provider, this.filter.contractType).subscribe(
      (resultYearMonth: any) => {
        this.numAnnoMeseData = resultYearMonth;

        const providerDefault = this.filter.provider;
        this.numAnnoMeseData =  this.filterFromDxc(providerDefault, resultYearMonth);

        const numAnnoMese = this.numAnnoMeseData[0] ? this.numAnnoMeseData[0] : null;
        this.filter.numAnnoMese = numAnnoMese;

        sessionStorage.setItem(this.SESSION_STORAGE_LABELS.DELTA_CHARGES_FILTER, JSON.stringify(this.filter));
        this.filterSingle = AllSettingsFilterModel.getFromDeltaChargesModel(this.filter);

        this.initFilter(this.filterSingle, isReset);

        this.loaderService.display(false);
      }, error => {
        console.log(error);
        this.loaderService.display(false);
    });
  }

  downloadTableCsv() {
    this.loaderService.display(true);
    this.getAllFilters();

    this.getNameSubscribe = this.deltaChargesService.getNameGenerateCsv(this.offset, this.filter)
      .subscribe(
        resultPage => {
          this.fileName = resultPage.toString();
          this.downloadSubscribe = this.deltaChargesService.getDownloadCsv(this.fileName)
            .subscribe( data => {
              toastr.success('CSV downloaded with success', 'Success');
              this.loaderService.display(false);
              FileSaver.saveAs(new Blob([data], { type: 'text/csv' }), this.fileName);
            });
        }, () => {
          toastr.error('Problem during download CSV, please contact the Administrator', 'Error');
          this.loaderService.display(false);
        });
  }

  downloadXlsx() {
    this.getAllFilters();
    const reportFilter = this.filter as DeltaChargesReportModel;
    if (this.reportSection) {
      reportFilter.numAnnoMeseTo = this.numAnnoFilterComponent.optionSelected;
      reportFilter.numAnnoMeseFrom = this.numAnnoFilterComponent.optionSelectedFrom;
    } else {
      reportFilter.numAnnoMeseTo = reportFilter.numAnnoMese;
      reportFilter.numAnnoMeseFrom = reportFilter.numAnnoMese;
    }
    if (!reportFilter.numAnnoMeseFrom && reportFilter.numAnnoMeseTo) {
      reportFilter.numAnnoMeseFrom = reportFilter.numAnnoMeseTo;
    } else if (reportFilter.numAnnoMeseFrom && !reportFilter.numAnnoMeseTo) {
      reportFilter.numAnnoMeseTo = reportFilter.numAnnoMeseFrom;
    } else {
      console.error('year month filter is missing');
    }

    this.loaderService.display(true);
    this.generateDeltaChargesXlsx(reportFilter);
  }

  shareXlsx() {
    this.getAllFilters();
    const reportFilter = this.filter as DeltaChargesReportModel;
    if (this.reportSection) {
      reportFilter.numAnnoMeseTo = this.numAnnoFilterComponent.optionSelected;
      reportFilter.numAnnoMeseFrom = this.numAnnoFilterComponent.optionSelectedFrom;
    } else {
      reportFilter.numAnnoMeseTo = reportFilter.numAnnoMese;
      reportFilter.numAnnoMeseFrom = reportFilter.numAnnoMese;
    }
    if (!reportFilter.numAnnoMeseFrom && reportFilter.numAnnoMeseTo) {
      reportFilter.numAnnoMeseFrom = reportFilter.numAnnoMeseTo;
    } else if (reportFilter.numAnnoMeseFrom && !reportFilter.numAnnoMeseTo) {
      reportFilter.numAnnoMeseTo = reportFilter.numAnnoMeseFrom;
    } else {
      console.error('year month filter is missing');
    }

    const dialogRef = this.dialog.open(DialogSendEmailComponent, {
      data: {
        currentBaseUrl: this.deltaChargesService.baseUrl,
        offset: this.offset,
        isComparing: this.isComparing,
        filter: reportFilter
      }
    });
  }

  generateDeltaChargesXlsx(reportFilter) {
    let fileName = 'Delta Charges';
    if (this.filter.isRecovery) {
      fileName = 'Delta Volumes Balance';
    }
    this.getNameSubscribe = this.deltaChargesService.getNameGenerateXlsx(this.offset, reportFilter, this.isComparing)
      .subscribe(
        resultPage => {
          const currentDate = this.getDate();
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(
              new Blob([resultPage],
                { type: this.EXCEL_TYPE }),
              fileName + ' - ' + currentDate + '.xlsx');
          } else {
            FileSaver.saveAs(new Blob([resultPage], { type: this.EXCEL_TYPE }),
              fileName + ' - ' + currentDate + ' From ' + reportFilter.numAnnoMeseFrom + ' To ' + reportFilter.numAnnoMeseTo + '.xlsx');
          }
          toastr.success('XLS downloaded with success', 'Success');
          this.loaderService.display(false);
        }, () => {
          toastr.error('Problem during download XLS, please contact the Administrator', 'Error');
          this.loaderService.display(false);
        });
  }

  getDate() {
    const date = new Date();
    return date.getFullYear() + '-' +
      String(date.getMonth() + 1).padStart(2, '0') + '-' +
      String(date.getDate()).padStart(2, '0');
  }

  // todo deprecated?
  downloadTableXls() {
    this.loaderService.display(true);
    const filter: DeltaChargesModel = new DeltaChargesModel();

    filter.numAnnoMese = this.numAnnoFilterComponent.numAnnoMeseFormControl.value;
    filter.provider = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED));
    
    filter.localCustomer = this.localCustomerFilterComponent.localCustomerObject;
    if(!this.filter.provider.cod.includes('KYN')){  
      filter.contractType = this.contractTypeFilterComponent.contractTypeObject;
      filter.region = this.regionFilterComponent.regionObject;
    }
    filter.isDeltaSignificativo = this.deltaSignificativo;
    filter.isClaims = this.claims;

    this.getNameSubscribe = this.deltaChargesService.getNameGenerateXlsx(this.offset, this.filter, this.isComparing)
      .subscribe(
        resultPage => {
              const currentDate = new Date();
              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(new Blob(
                  [resultPage],
                  { type: this.EXCEL_TYPE }),
                  'Delta Charges' + ' - ' + currentDate + '.xlsx');
              } else {
                FileSaver.saveAs(new Blob(
                  [resultPage],
                  { type: this.EXCEL_TYPE }),
                  'Delta Charges' + ' - ' + currentDate + '.xlsx');
              }
              toastr.success('XLS downloaded with success', 'Success');

              this.loaderService.display(false);
        }, () => {
          toastr.error('Problem during download XLS, please contact the Administrator', 'Error');
          this.loaderService.display(false);
        });
  }
  openDialogDownloadXlsx() {
    if (this.reportSection) {
      this.filterTable();
    }
    this.getAllFilters();

    const list: GenericArray[] = [
        {id: 'filter', value: this.filter},
        {id: 'offset', value: this.offset},
        {id: 'numAnnoMeseData', value: this.numAnnoMeseData},
        {id: 'serviceReportPage', value: this.SERVICE_REPORT_DOWNLOAD.DELTA_CHARGES}
      ],
      dialogRef = this.dialog.open(DialogYearMonthComponent, {
        data: {list}
      });
    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
    });

  }

  getAllFilters() {
    if (!this.reportSection) {
      this.filter.numAnnoMese = this.numAnnoFilterComponent.optionSelected;
      this.filter.numAnnoMeseRif = this.referenceMonthFilterComponent.optionSelected;
    }
    this.filter.localCustomer = this.localCustomerFilterComponent ? this.localCustomerFilterComponent.getSelectedObject() : null;
    
    this.filter.resourceUnit = this.resourceUnitFilterComponent.getSelectedObject();
    this.filter.isDeltaSignificativo = this.deltaFilterComponent.optionSelected;
    this.filter.isClaims = this.claimsFilterComponent.claims;
    this.loaderService.display(false);
  }

  isLocalCustomerFilterActive(): boolean {
    if (this.filter && this.filter.provider && this.filter.provider.cod) {
      if (this.filter.provider.cod === 'DXC') { return false; } else { return true; }
    }
    console.error('no provider found');
    return false;
  }

  ngOnDestroy(): void {

  }
}
